export default __webpack_public_path__ + "static/media/Woman_nursing_baby_and_humanitarian_worker.d708742d.jpg";